import { generatePath } from '@cibo/core'
import {
  PaginatedFieldsProvider,
  ReadOnlyPaginatedFieldsTable,
  fieldAcresColumn,
  fieldNameColumn,
  fieldUpdatedAtColumn,
} from '@cibo/landmanager'
import { Loading, useOrgUser } from '@cibo/profile'
import { fieldOpportunitiesColumn } from '@cibo/programs'
import { useParamAsInteger } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldTableHeader } from '../../../components/FieldTable/FieldTableHeader'
import { Section } from '../../../consts/Theme'
import { GROWERS_ROUTES } from '../../../navigation/types/growersRoutes'
import { UserLayout } from '../../UserProfile'

export const GrowersDetail = () => {
  const { t } = useTranslation('impact/pages/GrowersDetail')
  const userId = useParamAsInteger('userId')

  const user = useOrgUser(userId)

  const columns = useMemo(() => {
    return [
      fieldNameColumn({
        t,
        cellProps: { hideAcreage: true, hideLocation: false, thumbnailSize: 48 },
        overrides: { minWidth: 200 },
      }),
      fieldOpportunitiesColumn({ t, minWidth: 200 }),
      fieldAcresColumn({ t, minWidth: 30, maxWidth: 80 }),
      fieldUpdatedAtColumn({ t, minWidth: 40, maxWidth: 150 }),
    ]
  }, [t])

  if (!userId) return null

  return user.isLoading ? (
    <Stack flex={1} alignItems="center" justifyContent={'center'} spacing={3}>
      <Loading />
      <Typography color="text.secondary">{t('loading')}</Typography>
    </Stack>
  ) : user.data ? (
    <UserLayout>
      <Section sx={{ padding: 0.5, width: '100%' }}>
        <PaginatedFieldsProvider
          hideFilters={{
            userId: true,
            coverCrop: true,
            tillage: true,
            termsets: true,
            labels: true,
            lastUpdatedGt: true,
          }}
        >
          <Stack>
            <FieldTableHeader
              title={t('fields')}
              addFieldsButtonProps={{
                paths: {
                  draw: generatePath(GROWERS_ROUTES.DRAW_GROWER_FIELD, {
                    userId: userId.toString(),
                  }),
                  upload: generatePath(GROWERS_ROUTES.UPLOAD_GROWER_FIELD, {
                    userId: userId.toString(),
                  }),
                },
                size: 'medium',
                variant: 'contained',
                buttonText: t('addField(s)'),
              }}
              parentStackProps={{ sx: { margin: 2 } }}
            />
            <ReadOnlyPaginatedFieldsTable
              baseQuery={{ owner: userId }}
              columns={columns}
              hideCellFocus
            />
          </Stack>
        </PaginatedFieldsProvider>
      </Section>
    </UserLayout>
  ) : (
    <Stack spacing={3}>{t('notFound')}</Stack>
  )
}
